import xss from "xss";

import { KurslisteItem } from "rage_api";

export default class KurslisteStorage {
  constructor() {
    this.liste = [];
    this.kinds = {};
    this.makes = {};
    this.timestamp = null;
    this.errorStatus = null;
    this._loading = undefined;
    this._currentKinds = {};
    this._currentMakes = {};
  }

  setListe({ liste, timestamp }) {
    if (!Array.isArray(liste)) {
      this.liste = [];
      return;
    }
    const isValid = (nr) => !isNaN(nr) && nr !== null;
    this.liste = liste.map(a => {
      // validate data
      if (!a || (
        isNaN(a.betragAK) &&
        isNaN(a.betragVK) &&
        isNaN(a.betragMaKondAK) &&
        isNaN(a.betragMaKondVK) &&
        isNaN(a.betragEndkundeVK)
      )) return null;
      if (a.kind) this._currentKinds[a.kind] = true;
      if (a.make) this._currentMakes[a.make] = true;
      return KurslisteItem.constructFromObject({
        ...a,
        kennziffer: xss(a.kennziffer).trim(),
        isoCode: a.isoCode ? xss(a.isoCode).trim().toUpperCase() : null,
        bezeichnung: xss(a.bezeichnung).trim(),
        betragAK: isValid(a.betragAK) ? Number(a.betragAK) : null,
        betragVK: isValid(a.betragVK) ? Number(a.betragVK) : null,
        betragMaKondAK: isValid(a.betragMaKondAK) ? Number(a.betragMaKondAK) : null,
        betragMaKondVK: isValid(a.betragMaKondVK) ? Number(a.betragMaKondVK) : null,
        betragEndkundeVK: isValid(a.betragEndkundeVK) ? Number(a.betragEndkundeVK) : null,
      });
    }).filter(a => !!a);
    this.timestamp = new Date(timestamp);
  }

  getListe() {
    return this.liste;
  }

  createSelectorModel(allItems, usedItems) {
    let list = [{ name: "Alle", value: "" }];
    for (let key in allItems) {
      if (key in usedItems) list.push({ name: allItems[key], value: key });
    }
    return list;
  }

  setMakes(makes) {
    this.makes = makes && typeof makes === "object" ? makes : {};
  }

  getMakes() {
    return this.createSelectorModel(this.makes, this._currentMakes);
  }

  setKinds(kinds) {
    this.kinds = kinds && typeof kinds === "object" ? kinds : {};
  }

  getKinds() {
    return this.createSelectorModel(this.kinds, this._currentKinds);
  }

  loading(status) {
    this._loading = !!status;
  }

  isLoading() {
    return this._loading;
  }

  hasData() {
    return typeof this._loading === "boolean" && this._loading === false;
  }

  failed(error) {
    this.errorStatus = error;
  }

  getError() {
    return this.errorStatus ? this.errorStatus.message : "";
  }
}
